import { motion } from 'framer-motion';
import AboutHero from '../components/about/AboutHero';
import CoreValues from '../components/about/CoreValues';
import MissionVision from '../components/about/MissionVision';

export default function About() {
  return (
    <div className="bg-white">
      <section className="relative h-[200px] overflow-hidden">
        <motion.div
          initial={{ scale: 1.1, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
          className="absolute inset-0"
        >
          <img
            src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2000&q=80"
            alt="Modern business district"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/70" />
        </motion.div>
        
        <motion.div 
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center text-center"
        >
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">
              Our Story
            </h1>
            <p className="text-lg text-white/90 max-w-2xl mx-auto">
              Building a legacy of excellence and innovation across Africa
            </p>
          </div>
        </motion.div>
      </section>

      <AboutHero />
      <MissionVision />
      <CoreValues />
    </div>
  );
}